import { apiGet } from 'api';
import { GetResponsesResponse } from '../../types';

export const getResponses = (consultationId: number): Promise<GetResponsesResponse> =>
  apiGet<GetResponsesResponse>(`consultations/${consultationId}/responses`);
